export default __webpack_public_path__ + "static/media/330_dummy2016-musikschule01-mobile-de.522fae18.png";